import { FC, useCallback, useEffect, useState } from "react";
import styles from "./ModelInfo.module.scss";
import { IService, TServiceId } from "../../types/service";
import { Button } from "../ui";
import Checkbox from "../ui/Checkbox/Checkbox";
import { IRequestPatchUser } from "../../types/user";
import { updateUser } from "../../services/slices/user";
import { useAppDispatch, useAppSelector } from "../../services/hooks";
import { getServices } from "../../api/services";

export const BlockService = () => {
  const [checkedList, setCheckedList] = useState<TServiceId[]>([]);
  const [dataServices, setDataServices] = useState<Array<IService>>([]);
  const { user } = useAppSelector((state) => state.user);

  const fetchData = useCallback(async () => {
    const data: IService[] = await getServices();
    setDataServices(data.filter((item) => item.isDeleted === false));
    setCheckedList(
      data
        .filter(
          (service) =>
            user?.service.find((serv) => serv.id == service.id) &&
            service.isDeleted === false,
        )
        .map((service) => service.id),
    );
  }, [user?.service]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const dispatch = useAppDispatch();

  function onChange(checked: boolean, id?: number): void {
    if (!id) return;
    if (checked) {
      setCheckedList([...checkedList, id]);
    } else {
      setCheckedList(checkedList.filter((item) => item !== id));
    }
  }

  async function patchUser() {
    const newData: IRequestPatchUser = {
      service: checkedList.map((id) => ({ serviceId: id })),
    };
    dispatch(updateUser(newData));
  }

  return (
    <div className={styles.BlockService}>
      {dataServices.length === 0 ? (
        <div className={styles.notFound}>Information not found</div>
      ) : (
        <>
          <ul className={styles.ListIntim}>
            {dataServices.map((intim) => (
              <li className={styles.ListIntim_item} key={intim.id}>
                <Checkbox
                  checked={checkedList.includes(intim.id)}
                  onChange={onChange}
                  name={intim.id}
                  id={intim.id}
                >
                  {" "}
                  <p className={styles.ListIntim_text}>
                    {intim.serviceName} | {intim.description}
                  </p>
                </Checkbox>
              </li>
            ))}
          </ul>
          <div className={styles.ButtonBlock}>
            <div className={styles.Button}>
              <Button type="button" onClick={patchUser}>
                Änderungen speichern
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
